// src/components/DemoRequestModal.jsx
import React, { useState } from "react";
import { Modal, ModalBody, Row, Form } from "react-bootstrap";
import { sendMail } from "../services/mailservice";

const initialFormData = {
  name: "",
  email: "",
  phone: "",
  company: "",
  location: "",
  product: "",
};

export const DemoRequestModal = ({ show, onHide }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Please enter your name";
    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email";
    }
    if (!formData.phone.trim()) newErrors.phone = "Please enter your phone number";
    if (!formData.company.trim()) newErrors.company = "Please enter your company name";
    if (!formData.location.trim()) newErrors.location = "Please enter your location";
    if (!formData.product.trim()) newErrors.product = "Please select a product";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await sendMail({
        to: formData.email,
        subject: "New Demo Request",
        templateType: "demo",
        text: JSON.stringify(formData, null, 2),
      });
      alert("Mail sent successfully ✅");
      setFormData(initialFormData);
      onHide();
     window.location.reload();

    } catch (err) {
      console.error("Mail API Error:", err);
      alert("Failed to send mail ❌");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton></Modal.Header>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Row className="homereqmsghead justify_content_center mt-4">
            Request Demo
          </Row>

          {/* Name */}
          <Row className="floating-label mt-3">
            <input
              className="floating-input"
              type="text"
              name="name"
              placeholder=" "
              value={formData.name}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your name *</label>
            {errors.name && <span className="error">{errors.name}</span>}
          </Row>

          {/* Email */}
          <Row className="floating-label mt-0">
            <input
              className="floating-input"
              type="email"
              name="email"
              placeholder=" "
              value={formData.email}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your Email *</label>
            {errors.email && <span className="error">{errors.email}</span>}
          </Row>

          {/* Phone */}
          <Row className="floating-label mt-0">
            <input
              className="floating-input"
              type="text"
              name="phone"
              placeholder=" "
              value={formData.phone}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your Phone no *</label>
            {errors.phone && <span className="error">{errors.phone}</span>}
          </Row>

          {/* Company */}
          <Row className="floating-label mt-0">
            <input
              className="floating-input"
              type="text"
              name="company"
              placeholder=" "
              value={formData.company}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your Company Name</label>
            {errors.company && <span className="error">{errors.company}</span>}
          </Row>

          {/* Location */}
          <Row className="floating-label mt-0">
            <input
              className="floating-input"
              type="text"
              name="location"
              placeholder=" "
              value={formData.location}
              onChange={handleChange}
            />
            <span className="highlight"></span>
            <label>Your Location</label>
            {errors.location && <span className="error">{errors.location}</span>}
          </Row>

          {/* Product */}
          <Row className="homesecondtop mt-0">Product Interest</Row>
          <Row className="floating-label mt-0">
            <select
              className="floating-input"
              name="product"
              value={formData.product}
              onChange={handleChange}
            >
              <option value="">Select Product</option>
              <option value="Transportation Exchange Platform">
                Transportation Exchange Platform
              </option>
              <option value="Transportation Intelligence Platform">
                Transportation Intelligence Platform
              </option>
              <option value="Billing Platform">Billing Platform</option>
              <option value="Open Track & Trace Platform">
                Open Track & Trace Platform
              </option>
            </select>
            {errors.product && <span className="error">{errors.product}</span>}
          </Row>

          <Row className="justify_content_center mt-5">
            <button type="submit" className="homknowmorebtn">
              Submit
            </button>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};
